<template>
  <slot
    v-if="$slots.activator"
    name="activator"
    :activator="openModal"
  />

  <l-button
    v-else
    v-bind="$attrs"
    requires-auth
    @click.stop="openModal"
    @keypress.stop
  >
    <icon name="edit" set="regular" class="px-1 text-xs text-orange-600 hover:text-orange-700"/>
  </l-button>

  <modal
    :title="title"
    :show="showModal"
    scrollable
    @close="closeModal"
  >
    <l-form
      method="PATCH"
      :action="action"
      class="grid gap-5"
    >
      <slot/>
      <div class="flex gap-3 flex-row-reverse">
        <l-button
          variant="primary"
          type="submit"
        >
          {{ saveLabel }}
        </l-button>
        <l-button variant="light" @click="closeModal">
          Cancel
        </l-button>
      </div>
    </l-form>
  </modal>
</template>

<script setup>
import Icon from "@/components/Icon.vue"
import LButton from "@/components/buttons/LButton.vue"
import LForm from "@/components/forms/LForm.vue"
import Modal from "@/components/modals/Modal.vue"
import { ref } from "vue"

defineOptions({
  inheritAttrs: false,
})

defineProps({
  buttonClass: String,
  title: String,
  action: String,
  saveLabel: { type: String, default: "Save" },
  user: { type: Object },
})

const showModal = ref(false)

const closeModal = () => {
  showModal.value = false
}

const openModal = () => {
  showModal.value = true
}
</script>
